<template>
  <div class="page digital">
    <progress max="100" value="0"></progress>
    <section class="section section__bg-white section__vw">
      <div class="main-banner jarallax">
        <img
          src="../assets/images/digital/banner.jpg"
          alt=""
          class="jarallax-img"
        />
        <div class="banner-content">
          <div class="container">
            <h1 class="headline-h1">Wir sind digital und vernetzt</h1>
          </div>
        </div>
      </div>
      <div class="container container__pw">
        <div class="content-wrapper">
          <h3>Digitalisierung bei der ODR</h3>
          <p>
            Bei der EnBW ODR digitalisieren wir laufend unsere Prozesse, um noch
            effizienter und vernetzter arbeiten zu können. Dabei steht auch der
            Kundennutzen im Vordergrund: Mit unseren digitalen Services wie der
            digitalen Bauleitplanung über unser Geoinformationssystem oder
            unserem Chatbot FRIDA bieten wir unseren Kundinnen und Kunden
            praktische digitale Alltagshelfer.
          </p>
          <h3>Digital optimiert</h3>
          <p>
            Der EnBW-Konzern transformiert seine komplette IT-Systemlandschaft
            unter dem Projekt „sCore25“, das steht für „smart Core“ –
            intelligenter Kern – und Strategie 2025. Auch wir haben uns der
            Vereinheitlichung angeschlossen und 2022 den Umbau unserer internen
            IT-Struktur im Projekt „ODRgoessCORE“ abgeschlossen. Mit einem
            abteilungsübergreifenden ERP-System (Enterprise Ressource Planning)
            konnten wir so teilweise unsere Prozesse vereinfacht und
            einheitliche Standards geschaffen. Vor dem „Go-Live“ unseres neuen
            ERP-Systems haben wir allen Mitarbeitenden, die mit dem System
            arbeiten, Vertiefungsschulungen angeboten und letzte Anpassungen
            vorgenommen. Im Juni war es dann so weit: Wir haben den Schal-ter
            offiziell umgelegt und arbeiten seither mit dem neuen Programm SAP
            S/4.
          </p>
        </div>
      </div>
    </section>

    <section class="section section__bg-dark_grey">
      <div class="container">
        <div class="main-blog">
          <div class="blog-item">
            <div class="blog-img">
              <img
                src="../assets/images/digital/img_blog_01.jpg"
                alt=""
                srcset=""
              />
            </div>
            <div class="blog-text">
              <h3>Digital beraten</h3>
              <p class="text-center">
                <img
                  src="../assets/images/digital/frida_nina.png"
                  alt=""
                  srcset=""
                  class="img_frida"
                />
              </p>
              <p>
                Seit 2020 ist FRIDA fester Teil unseres EnBW ODR-Teams: Unsere
                digitale Kollegin beantwortet rund um die Uhr auf unserer
                Website die Fragen unserer Kundinnen und Kunden. Und unser
                Chatbot wird gut angenommen, 2022 haben wir einen neuen Rekord
                für die Nutzung von FRIDA erreicht: Rund 23.760 Kunden nutzten
                FRIDA, um ihr mindestens eine Frage zu stellen. Dabei wurden
                insgesamt 49.840 einzelne Nachrichten verfasst. Am häufigsten
                wurden unserer digitalen Assistentin Fragen zu Tarifen und
                Produkten gestellt, gefolgt von der Zählerstandserfassung und
                dem Umzugsservice.
              </p>
              <p>
                „Unsere FRIDA lernt ständig dazu, indem wir ihr immer wieder
                Themen antrainieren. Sowohl das Sprachmodell erweitert sich
                dadurch monatlich als auch ihre Fähigkeit, zum Beispiel auf
                Emotionen zu reagieren. Sie kann nun auch erkennen, wenn ein
                Kunde ein Lob oder Kritik ausspricht“, erklärt Bernd Eßlinger,
                Bereichsleiter Kundenservice und Abrechnungsprozesse.
              </p>
            </div>
          </div>
          <div class="blog-item">
            <div class="blog-img">
              <img
                src="../assets/images/digital/img_blog_02.jpg"
                alt=""
                srcset=""
              />
            </div>
            <div class="blog-text">
              <h3>Digital kommuniziert</h3>
              <p>
                Wir pflegen auch auf den Social-Media-Kanälen den engen
                Austausch mit unseren Kundinnen und Kunden. Seit 2022 gehen wir
                ebenso verstärkt auf LinkedIn in den Dialog. Auf dem
                Karrierenetzwerk suchen wir den Austausch zu potenziellen
                Arbeitskräften und informieren über unsere Arbeitgebermarke.
                Auch nutzen wir die Plattform, um uns weiter mit Akteuren aus
                der Energiewirtschaft zu vernetzen und über aktuelle Themen und
                Herausforderungen zu sprechen. Mehr als 650 Personen folgen uns
                auf LinkedIn. Zudem sind wir auf Facebook und Instagram aktiv.
              </p>
              <h4>
                So viele Menschen folgen uns auf unseren sozialen Kanälen:
              </h4>
              <b-container fluid>
                <b-row align-v="stretch">
                  <b-col sm="12" md="6" align-h="center">
                    <div class="main-bubble">
                      <div class="bubble bubble__round-blue">
                        <h4>ODR</h4>
                        <p>
                          Facebook <strong>2.100</strong><br />
                          Instagram <strong>1.118</strong><br />
                          LinkedIn <strong>676</strong>
                        </p>
                      </div>
                    </div>
                  </b-col>
                  <b-col sm="12" md="6">
                    <div class="main-bubble">
                      <div class="bubble bubble__round-green">
                        <h4>Netze ODR</h4>
                        <p>
                          Instagram <strong>541</strong><br />
                          LinkedIn <strong>208</strong>
                        </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </div>
          <div class="blog-item">
            <div class="blog-img">
              <img
                src="../assets/images/digital/img_blog_03.jpg"
                alt=""
                srcset=""
              />
            </div>
            <div class="blog-text">
              <h3>Digital geplant</h3>
              <p>
                Unser Geoinformationssystem (GIS), das alle wichtigen Daten,
                Karten und Pläne zu unseren Netzen bereithält, werden wir in den
                kommenden Jahren auf neue Füße stellen. Im Berichtsjahr haben
                wir den Beschluss gefasst und die Vorprojektphase gestartet.
                „Die EnBW ODR und die Netze ODR benötigen auch weiterhin
                leistungsfähige Systeme, die sich an die Gegebenheiten der
                Energiewende mit ihren dezentralen Anlagen anpassen“, erklärt
                Patrick Weber, Teamleiter IT und Geo-Informationsdienste.
              </p>
            </div>
          </div>
          <div class="blog-item">
            <div class="blog-img">
              <img
                src="../assets/images/digital/img_blog_04.jpg"
                alt=""
                srcset=""
              />
            </div>
            <div class="blog-text">
              <h3>Digital sicher</h3>
              <p>
                Im Berichtsjahr wurde unsere Informationssicherheit erneut
                erfolgreich rezertifiziert. Im Überwachungsaudit bestätigten die
                Prüfer des TÜV Süd Managementservice die Aufrechterhaltung der
                Zertifikate gemäß der Norm DIN EN ISO/IEC 27001:2017 und des
                IT-Sicherheitskatalogs gemäß §11 Abs. 1a EnWG (08/2025).
                Zusätzlich simulieren wir regelmäßig Angriffe per E-Mail auf
                unser Unternehmen. Ziel ist es, unsere Mitarbeitenden im Umgang
                mit E-Mails zu sensibilisieren und zu trainieren. Durch
                zusätzliche Risikobewertungen analysieren wir unter anderem die
                Auswirkungen des Ukraine-Konflikts und die zunehmende
                Digitalisierung auf unser Unternehmen. Um Risiken zu minimieren,
                hat die EnBW ODR das Programm „Cyber Defense“ aufgesetzt. „Um
                unsere kritischen Geschäftsprozesse jederzeit aufrecht erhalten
                zu können, ist es uns wichtig, schnell und wirkungsvoll auf
                jegliche Art von Cyber-Angriffen reagieren zu können. Deshalb
                haben wir ein Programm zur Stärkung der Resilienz gegenüber
                solchen Angriffen aufgesetzt“, sagt Alexander Halbig,
                Information Security Officer der EnBW ODR.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="main-nav-section">
      <div class="container">
        <router-link to="/stabilitaet" tag="div"
          ><a class="link link__back"></a
        ></router-link>
        <router-link to="/regional" tag="div"
          ><a class="link link__next"></a
        ></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import "object-fit-images";
import { jarallax, jarallaxVideo } from "jarallax";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import $ from "jquery";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "Digital",
  components: {},
  mounted: function () {
    window.scrollTo(0, 0);
    this.scrollAnimation();
  },
  methods: {
    playAnimation() {
      $(".counter").each(function () {
        var count = $(this),
          zero = { val: 0 };
        gsap.to(zero, {
          duration: 2,
          val: count.data("number"),
          onUpdate: countNumber,
        });
        function countNumber() {
          var final = gsap.utils.snap(1, zero.val);
          count.text(final);
        }
      });
    },
    scrollAnimation() {
      jarallaxVideo();
      jarallax(document.querySelectorAll(".jarallax"), {
        speed: 0.2,
      });

      gsap.to("progress", {
        value: 100,
        ease: "none",
        scrollTrigger: { scrub: 0.15 },
      });

      const contentBlocs = gsap.utils.toArray(".content-wrapper");
      contentBlocs.forEach((contentBloc) => {
        gsap.from(contentBloc, {
          y: 50,
          opacity: 0,
          duration: 1,
          scrollTrigger: {
            trigger: contentBloc,
            toggleActions: "play pause resume reset",
          },
        });
      });

      const animCharts = gsap.utils.toArray(".anim-chart");
      animCharts.forEach((animChart) => {
        gsap.from(animChart, {
          scale: 0,
          opacity: 0,
          duration: 2,
          scrollTrigger: {
            trigger: animChart,
            toggleActions: "play pause resume reset",
          },
        });
      });

      const itemBlogs = gsap.utils.toArray(".blog-item");
      itemBlogs.forEach((itemBlog) => {
        const imgBlog = itemBlog.querySelectorAll(".blog-img");
        const textBlog = itemBlog.querySelectorAll(".blog-text");
        gsap.from(imgBlog, {
          scale: 0.5,
          opacity: 0,
          duration: 1.2,
          scrollTrigger: {
            trigger: itemBlog,
            toggleActions: "play none none none",
          },
        });
        gsap.from(textBlog, {
          opacity: 0,
          duration: 1.2,
          scrollTrigger: {
            trigger: itemBlog,
            toggleActions: "play none none none",
          },
        });
      });

      const bubble = document.querySelectorAll(".main-bubble");
      gsap.from(bubble, {
        scale: 0,
        opacity: 0,
        duration: 1,
        scrollTrigger: {
          trigger: bubble,
          toggleActions: "play pause resume reset",
          start: "bottom bottom",
          end: "top top",
          onEnter: this.playAnimation(),
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "./../scss/views/digital.scss";
</style>
